import { Form, Input, Row, Col, DatePicker, TimePicker, Select } from 'antd';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { PLATAFORMAS, CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import PropTypes from 'prop-types';
import * as fieldMsgs from 'constants/formFieldsMessages';
import dayjs from 'dayjs';

const UbicacionWebHallazgos = ({ form }) => {
  const plataformas = useSelector(selectCatalogByName(PLATAFORMAS));
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  const handleInputSelectConfirmPlataformaDigital = (e, optionSelect) => {
    if (optionSelect.url !== undefined) {
      return form.setFieldsValue({
        plataforma_digital: e,
        plataforma: optionSelect.descripcion,
        URL: optionSelect.url
      });
    }
    return form.setFieldsValue({
      plataforma_digital: e,
      plataforma: optionSelect.descripcion,
      URL: ''
    });
  };

  const inputSelectAutocompletePlataformaDigital = (dataOptions) => {
    const datosGralesAutocomplete = (
      <Select
        placeholder="Selecciona"
        fieldNames={{
          value: 'idPlataforma',
          label: 'descripcion'
        }}
        options={dataOptions}
        filterOption={(inputValue, option) =>
          option.descripcion?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={handleInputSelectConfirmPlataformaDigital}
        showSearch
      />
    );
    return datosGralesAutocomplete;
  };

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          <Col xs={7}>
            <Form.Item
              name="fecha_busqueda"
              label="Fecha de búsqueda"
              rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
              <DatePicker
                placeholder="dd/mm/aaaa"
                style={{ width: '100%' }}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <Form.Item
              name="hora_busqueda"
              label="Hora de búsqueda"
              rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
              <TimePicker placeholder="00:00" />
            </Form.Item>
          </Col>
          <Col xs={7}>
            <Form.Item shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name="plataforma_digital"
                    label="Plataforma digital"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    {inputSelectAutocompletePlataformaDigital(plataformas)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={6}>
            <Form.Item
              name="URL"
              label="URL"
              rules={[
                {
                  pattern: /^[a-zA-Z0-9@:%_\\+\-.~#?&//=]*$/,
                  message: 'URL no válida'
                },
                { required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }
              ]}>
              <Input placeholder="https://" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

UbicacionWebHallazgos.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};

export default UbicacionWebHallazgos;
